module.exports = __webpack_public_path__ + "img/main_left.25b98bfe.jpg";